import React from 'react';

/**
 * React component for the Footer Section.
 */
export const Footer = () => {
  return (
    <footer className="footer">
      <p>Source code on <a href="https://github.com/raravi/sudoku">Github</a></p>
    </footer>
  )
}
